import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import {
  type DataTestId,
  type StylingProps,
} from '@dynatrace/strato-components/core';

import { suffixWrapperCSS } from './TitleBar.sty.js';

//#region Typings
/**
 * Accepted properties for the TitleBar Suffix
 * @public
 */
export interface TitleBarSuffixProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Suffix slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Suffix component
 * @public
 */
export const Suffix = forwardRef<HTMLDivElement, TitleBarSuffixProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
    }: TitleBarSuffixProps = props;

    return (
      <div
        ref={forwardedRef}
        className={clsx(suffixWrapperCSS, consumerClassName)}
        style={consumerStyle}
        data-testid={dataTestId}
      >
        {children}
      </div>
    );
  },
);
